import React from 'react';
import { User } from 'lucide-react';

const StudentInfoCard = ({ student }) => {
  if (!student) return null;

  return (
    <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
      <div className="bg-[#f8f9fa] border-b px-4 py-3">
        <h2 className="text-lg font-semibold text-[#202654] flex items-center">
          <User className="h-5 w-5 mr-2 text-[#202654]" />
          Informations de l'étudiant
        </h2>
      </div>
      <div className="p-4 space-y-4">
        <div className="flex items-center p-3 bg-[#f8f9fa] rounded-lg">
          <div className="bg-[#202654] rounded-full h-10 w-10 flex items-center justify-center text-white mr-3">
            {student.genre === 'M' ? 'M' : 'F'}
          </div>
          <div>
            <p className="font-medium">{student.prenom} {student.nom}</p>
            <p className="text-sm text-gray-500">Matricule: {student.matricule || 'Non défini'}</p>
          </div>
        </div>
        
        <div className="space-y-2 divide-y divide-gray-100">
          <div className="flex justify-between py-1">
            <span className="text-gray-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-[#202654]" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M6 3a1 1 0 011-1h6a1 1 0 011 1v2h3a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h3zm6 2H8V4h4v1z" clipRule="evenodd" />
              </svg>
              Genre
            </span>
            <span className="font-medium">{student.genre === 'M' ? 'Masculin' : 'Féminin'}</span>
          </div>
          <div className="flex justify-between py-1">
            <span className="text-gray-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-[#202654]" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
              </svg>
              Date de naissance
            </span>
            <span className="font-medium">{new Date(student.date_naissance).toLocaleDateString('fr-FR')}</span>
          </div>
          <div className="flex justify-between py-1">
            <span className="text-gray-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-[#202654]" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              Contact
            </span>
            <span className="font-medium">{student.contact}</span>
          </div>
          <div className="flex justify-between py-1">
            <span className="text-gray-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-[#202654]" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              Email
            </span>
            <span className="font-medium">{student.email || 'Non défini'}</span>
          </div>
        </div>

        {student.parent && (
          <div className="mt-2">
            <div className="bg-[#f8f9fa] px-3 py-2 rounded-md mt-4 mb-3">
              <h3 className="text-[#202654] font-semibold text-sm">Parent / Tuteur</h3>
            </div>
            <div className="space-y-2 divide-y divide-gray-100">
              <div className="flex justify-between py-1">
                <span className="text-gray-600">Nom complet:</span>
                <span className="font-medium">{student.parent?.prenom_parent || ''} {student.parent?.nom_parent || 'Non défini'}</span>
              </div>
              <div className="flex justify-between py-1">
                <span className="text-gray-600">Contact:</span>
                <span className="font-medium">{student.parent?.contact_parent || 'Non défini'}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentInfoCard;
